









import { Component, Vue } from "vue-property-decorator";
import DefaultLayout from "./components/layouts/_DefaultLayout.vue";
import BasicLayout from "./components/layouts/_BasicLayout.vue";
import store from "./store/index";
import { setUpResponseInterceptors } from "@/services/interceptors";
import "@/assets/style/main.scss";
import AutoLogout from "./components/common/AutoLogout.vue";

@Component({
    components: {
        "default-layout": DefaultLayout,
        "basic-layout": BasicLayout,
        "auto-logout": AutoLogout
    }
})
export default class App extends Vue {
    get layout() {
        const isloggedIn: boolean = store.getters["authentication/isLoggedIn"];
        return isloggedIn ? this.$route.meta.layout || "default-layout" : "basic-layout";
    }

    public created(): void {
        setUpResponseInterceptors();
    }
}
